import { Maybe } from 'maybe-not';
import SDKMessageBus from '../utility/message-bus';
import { IDict } from '../types/utility';

export interface IModalButton {
    text: string;
    actionName: string;
}

export interface IUuxPlatformModalOptions {
    title: string;
    message: string;
    modalType: 'success' | 'error' | 'info' | 'warning';
    transInfo?: any;
    infoList?: string[];
    addlInfo?: string;
    close?: boolean;
    isBlocking?: boolean;
    customMarkup?: string;
    button1?: IModalButton;
    button2?: IModalButton;
    button3?: IModalButton;
}

// temporary until Q2Config types are finalized
export type IQ2ConfigPlatformModalOptions = IDict<string>;

export type IPlatformModalOptions = IUuxPlatformModalOptions | IQ2ConfigPlatformModalOptions;

export default function showModal(messageBus: SDKMessageBus, platformCapabilites: Set<string>) {
    if (!platformCapabilites.has('sendModal')) {
        return;
    }

    return function(modalOptions: IPlatformModalOptions): Promise<string> {
        return messageBus
            .sendRequest<{ actionName: string }>(
                `sendModal`,
                Maybe.just(modalOptions).map(JSON.stringify)
            )
            .then(response => {
                return response.value.actionName;
            });
    };
}
